<!-- Log or edit an entry — generated from .appfactory/product-plan.json. -->
<template>
  <IonPage>
    <IonHeader :translucent="true">
      <IonToolbar>
        <IonButtons slot="start"><IonBackButton /></IonButtons>
        <IonTitle>Log or edit an entry</IonTitle>
      </IonToolbar>
    </IonHeader>

    <IonContent :fullscreen="true">
      <!-- A record that does not exist is a real state, not a crash: a deep link
           can outlive the thing it points at. -->
      <div v-if="!row" class="empty">
        <h2>Not found</h2>
        <p>That is no longer here. It may have been deleted since this link was made.</p>
        <IonButton @click="goBack">Go back</IonButton>
      </div>

      <IonList v-else :inset="true">
        <IonItem>
          <IonLabel>
            <p>name</p>
            <h2>{{ row.name }}</h2>
          </IonLabel>
        </IonItem>
        <IonItem>
          <IonLabel>
            <p>category</p>
            <h2>{{ row.category }}</h2>
          </IonLabel>
        </IonItem>
        <IonItem>
          <IonLabel>
            <p>intervalMonths</p>
            <h2>{{ row.intervalMonths }}</h2>
          </IonLabel>
        </IonItem>
        <IonItem>
          <IonLabel>
            <p>notes</p>
            <h2>{{ row.notes }}</h2>
          </IonLabel>
        </IonItem>
        <IonItem>
          <IonLabel>
            <p>createdAt</p>
            <h2>{{ row.createdAt }}</h2>
          </IonLabel>
        </IonItem>
        <IonItem>
          <IonLabel>
            <p>archived</p>
            <h2>{{ row.archived }}</h2>
          </IonLabel>
        </IonItem>
      </IonList>
    </IonContent>
  </IonPage>
</template>

<script setup>
import {
  IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonItem, IonLabel,
  IonButtons, IonBackButton, IonButton,
} from '@ionic/vue';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { findTask } from '../store.js';

const route = useRoute();
const router = useRouter();
const row = computed(() => findTask(route.params.id));
const goBack = () => router.back();
</script>

<style scoped>
.empty { padding: 3rem 1.25rem; text-align: center; color: var(--ion-color-medium); }
.empty h2 { color: var(--ion-text-color); font-size: 1.25rem; margin: 0 0 .5rem; }
.empty p { margin: 0 0 1.5rem; }
</style>
